import { render, staticRenderFns } from "./ReportImageDamage.vue?vue&type=template&id=0bee0d2c"
import script from "./ReportImageDamage.vue?vue&type=script&lang=ts"
export * from "./ReportImageDamage.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageDamage.vue?vue&type=style&index=0&id=0bee0d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports